import { render, staticRenderFns } from "./PoiDetail.vue?vue&type=template&id=7942b86e"
import script from "./PoiDetail.vue?vue&type=script&lang=js"
export * from "./PoiDetail.vue?vue&type=script&lang=js"
import style0 from "./PoiDetail.vue?vue&type=style&index=0&id=7942b86e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports